import React, { ReactNode, Ref, forwardRef, useState, useEffect } from "react"
import { Link, useStaticQuery, graphql, withPrefix } from "gatsby"
import { Helmet } from "react-helmet"
import parse from "html-react-parser"
import { GlobalStyle } from "@interia/common"
import { Header } from "../header"
import { Footer } from "../footer"
import { MainMenuItem } from "../../hooks/useMainMenu"
import { globalHistory } from "@reach/router"

type Props = {
  children: ReactNode
  actualSite?: string
  headerChildren?: ReactNode
  menuItems: MainMenuItem[]
  logoUrl: {
    external: boolean
    url: string
    image: any
  }
  footer?: any
  gemiusId?: string
}

const Layout = forwardRef(
  (
    {
      children,
      actualSite,
      headerChildren,
      menuItems,
      logoUrl,
      footer,
      gemiusId,
    }: Props,
    ref
  ) => {
    const [scriptLoaded, setScriptLoaded] = useState(true)

    useEffect(() => {
      return globalHistory.listen(({ action }) => {
        // @ts-ignore: Unreachable code error
        window.iwaAppType = "SPA"
        // @ts-ignore: Unreachable code error
        // @ts-ignore: Unreachable code error
        if (window.iwa) {
          // @ts-ignore: Unreachable code error
          window.iwa("send", "ppv")
          if (gemiusId) {
            // @ts-ignore: Unreachable code error
            pp_gemius_hit(gemiusId)
          }
        }
      })
    }, [])

    return (
      <div className="global-wrapper">
        <GlobalStyle />
        <Header
          logoUrl={logoUrl}
          items={menuItems}
          actualSite={actualSite}
          ref={ref}
        >
          {headerChildren}
        </Header>
        <main style={{ overflowX: "hidden", overflowY: "hidden" }}>
          {children}
        </main>
        {footer && <Footer data={footer} />}
        <Helmet>
          <script
            src={withPrefix("interia-inserts.js")}
            type="text/javascript"
          />
        </Helmet>
      </div>
    )
  }
)

export default Layout
